import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import type { IncidentCaseV2ReadPanelProps } from '../../incidentCaseV2Steps'
import { ReadItem, ReadWide } from '../readLayout'
import {
  recordedPractices,
  restrictiveDetails,
  savedRestrictivePractices,
  yesNo
} from '../readRules'
import RestrictivePracticeReadBlock from './restrictivePractices/RestrictivePracticeReadBlock'

const testId = 'incident-case-v2-view-restrictive-practices'

/**
 * Step 4, read only: whether restrictive practices were used, any details,
 * and each practice recorded.
 */
const RestrictivePracticesReadPanel = ({
  incidentReport
}: IncidentCaseV2ReadPanelProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  const saved = savedRestrictivePractices(incidentReport)
  const details = restrictiveDetails(saved)

  return (
    <>
      <ReadWide>
        <ReadItem
          label={t(incidentReportsConstants.CASE_V2_RESTRICTIVE_ANY_USED)}
          value={yesNo(t, saved?.hasBeenApplied)}
          testId={`${testId}-any-used`}
        />
      </ReadWide>
      {details && (
        <ReadWide>
          <ReadItem
            label={t(incidentReportsConstants.CASE_V2_VIEW_RESTRICTIVE_DETAILS)}
            value={details}
            testId={`${testId}-details`}
          />
        </ReadWide>
      )}
      {recordedPractices(saved).map((practice, index) => (
        <RestrictivePracticeReadBlock
          // Read only and never reordered, so the position is stable.
          // biome-ignore lint/suspicious/noArrayIndexKey: see above
          key={index}
          number={index + 1}
          practice={practice}
          testId={`${testId}-practice-${index}`}
        />
      ))}
    </>
  )
}

export default RestrictivePracticesReadPanel
